const t = {
  "en-au": {
    domain: "https://www.vistaprint.com.au",
    proadvantageProgram: !0,
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2", "call_me_v2"]
  },
  "en-nz": {
    domain: "https://www.vistaprint.co.nz",
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2"]
  },
  "en-sg": {
    domain: "https://www.vistaprint.sg",
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2"]
  },
  "en-ie": {
    domain: "https://www.vistaprint.ie",
    contactUsComponents: ["phone_v2", "email_v2", "call_me_v2", "live_chat_v2"]
  },
  "pt-pt": {
    domain: "https://www.vistaprint.pt",
    contactUsComponents: ["phone_v2", "call_me_v2", "email_v2"]
  },
  "es-es": {
    domain: "https://www.vistaprint.es",
    proadvantageProgram: !0,
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2"]
  },
  "en-in": {
    domain: "https://www.vistaprint.in",
    contactUsComponents: ["phone_v2", "email_v2"]
  },
  "en-us": {
    domain: "https://www.vistaprint.com",
    proadvantageProgram: !0,
    contactUsComponents: ["phone_v2", "email_v2", "call_me_v2", "live_chat_v2"]
  },
  "en-gb": {
    domain: "https://www.vistaprint.co.uk",
    proadvantageProgram: !0,
    contactUsComponents: ["phone_v2", "email_v2", "call_me_v2", "live_chat_v2"]
  },
  "it-it": {
    domain: "https://www.vistaprint.it",
    proadvantageProgram: !0,
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2"]
  },
  "nl-nl": {
    domain: "https://www.vistaprint.nl",
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2", "call_me_v2"]
  },
  "nl-be": {
    domain: "https://www.vistaprint.be",
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2"]
  },
  "fr-be": {
    domain: "https://www.vistaprint.be",
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2"]
  },
  "sv-se": {
    domain: "https://www.vistaprint.se",
    contactUsComponents: ["phone_v2", "email_v2", "call_me_v2", "live_chat_v2"]
  },
  "nb-no": {
    domain: "https://www.vistaprint.no",
    contactUsComponents: ["phone_v2", "email_v2", "call_me_v2", "live_chat_v2"]
  },
  "fi-fi": {
    domain: "https://www.vistaprint.fi",
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2", "call_me_v2"]
  },
  "fr-fr": {
    domain: "https://www.vistaprint.fr",
    proadvantageProgram: !0,
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2"]
  },
  "da-dk": {
    domain: "https://www.vistaprint.dk",
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2", "call_me_v2"]
  },
  "fr-ca": {
    domain: "https://www.vistaprint.ca",
    proadvantageProgram: !0,
    contactUsComponents: ["phone_v2", "email_v2", "call_me_v2", "live_chat_v2"]
  },
  "en-ca": {
    domain: "https://www.vistaprint.ca",
    proadvantageProgram: !0,
    contactUsComponents: ["phone_v2", "email_v2", "call_me_v2", "live_chat_v2"]
  },
  "de-de": {
    domain: "https://www.vistaprint.de",
    proadvantageProgram: !0,
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2"]
  },
  "de-at": {
    domain: "https://www.vistaprint.at",
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2"]
  },
  "fr-ch": {
    domain: "https://www.vistaprint.ch",
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2", "call_me_v2"]
  },
  "it-ch": {
    domain: "https://www.vistaprint.ch",
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2", "call_me_v2"]
  },
  "de-ch": {
    domain: "https://www.vistaprint.ch",
    contactUsComponents: ["phone_v2", "email_v2", "live_chat_v2", "call_me_v2"]
  },
  "es-us": {
    domain: "https://www.vistaprint.com",
    proadvantageProgram: !0,
    contactUsComponents: ["phone_v2", "email_v2", "call_me_v2", "live_chat_v2"]
  }
};
export {
  t as CHANNELS_CONFIG
};
//# sourceMappingURL=contact-channels49.js.map
